<template lang="pug">
table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
  thead.thead-light
    tr
      th.text-center(width="5%")
        span #
      th(width="7%")
        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
      th(v-if="!isOperator" width="7%")
        span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
      th(width="7%")
        span(:title="$t('ui.contact_phone')") {{ $t('ui.contact_phone') }}
      th.text-center(width="7%")
        span(:title="$t('ui.ongoing')") {{ $t('ui.ongoing') }}
      th(width="6%")
        span(:title="$t('ui.promotion_id')") {{ $t('ui.promotion_id') }}
      th(width="10%")
        span(:title="$t('ui.criteria')") {{ $t('ui.criteria') }}
      th.text-center(width="7%")
        span(:title="$t('ui.rollover')") {{ $t('ui.rollover') }}
      th.text-right(width="10%")
        span(:title="$t('ui.target_amount')") {{ $t('ui.target_amount') }}
      th.text-right(width="10%")
        span(:title="$t('ui.accumulate_win')") {{ $t('ui.accumulate_win') }}
      th.text-right(width="10%")
        span(:title="$t('ui.accumulate_turnover')") {{ $t('ui.accumulate_turnover') }}
      th.text-right(width="16%")
        span(:title="$t('ui.signup_date')") {{ $t("ui.signup_date") }}
  tbody.clusterize-content
    tr(v-if="tbl.length == 0")
      td(:colspan="isOperator ? '11' : '12'").text-center
        span {{ $t('message.no_data_available') }}
    tr(v-for="(item, index) in tbl")
      td.text-center
        span(:title="index + 1") {{ index + 1 }}
      td
        span(:title="item.account_id") {{ item.account_id }}&nbsp;
      td(v-if="!isOperator")
        span(:title="item.parent_id") {{ item.parent_id }}&nbsp;
      td
        span(:title="item.contact_phone") {{ item.contact_phone }}&nbsp;
      td.text-center
        span(:title="item.ongoing") {{ item.ongoing }}&nbsp;
      td
        span(:title="item.promotion_id") {{ item.promotion_id }}&nbsp;
      td
        span(:title="item.criteria") {{ item.criteria }}&nbsp;
      td.text-center
        span.font-weight-bold(:title="item.rollover") {{ item.rollover }}
      td.text-right
        span.font-weight-bold(:class="$helpers.fontClassName(item.target_amount)" :title="$n(item.target_amount, 'currency')") {{ $n(item.target_amount, 'currency') }}
      td.text-right
        span.font-weight-bold(:class="$helpers.fontClassName(item.accumulate_win)" :title="$n(item.accumulate_win, 'currency')") {{ $n(item.accumulate_win, 'currency') }}
      td.text-right
        span.font-weight-bold(:class="$helpers.fontClassName(item.accumulate_turnover)" :title="$n(item.accumulate_turnover, 'currency')") {{ $n(item.accumulate_turnover, 'currency') }}
      td.text-right
        span(:title="$moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss') }}
    tr.footer
      td.text-right(:colspan="isOperator ? '8' : '9'")
        span.d-block {{ $t("ui.sub_total") }}
      td.text-right
        span.font-weight-bold(:class="$helpers.fontClassName(subTotalAccWin)" :title="$n(subTotalAccWin, 'currency')") {{ $n(subTotalAccWin, 'currency') }}
      td.text-right
        span.font-weight-bold(:class="$helpers.fontClassName(subTotalAccTurnover)" :title="$n(subTotalAccTurnover, 'currency')") {{ $n(subTotalAccTurnover, 'currency') }}
      td
        span
    tr.footer
      td.text-right(:colspan="isOperator ? '8' : '9'")
        span {{ $t("ui.grand_total") }}
      td.text-right
        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAccWin)" :title="$n(grandTotalAccWin, 'currency')") {{ $n(grandTotalAccWin, 'currency') }}
      td.text-right
        span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAccTurnover)" :title="$n(grandTotalAccTurnover, 'currency')") {{ $n(grandTotalAccTurnover, 'currency') }}
      td
        span 
</template>

<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalAccWin: 0,
    grandTotalAccWin: 0,
    subTotalAccTurnover: 0,
    grandTotalAccTurnover: 0
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.subTotalAccWin = 0
      this.grandTotalAccWin = 0
      this.subTotalAccTurnover = 0
      this.grandTotalAccTurnover = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalAccWin = parseFloat(this.subTotalAccWin) + parseFloat(value["accumulate_win"]);
          this.subTotalAccTurnover = parseFloat(this.subTotalAccTurnover) + parseFloat(value["accumulate_turnover"]);
        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalAccWin = totalTbl[0]["accumulate_win"];
          this.grandTotalAccTurnover = totalTbl[0]["accumulate_turnover"];
        }
      }
    }
  }
};
</script>